import { render, staticRenderFns } from "./fullnews.vue?vue&type=template&id=b97bda5a&scoped=true&"
import script from "./fullnews.vue?vue&type=script&lang=js&"
export * from "./fullnews.vue?vue&type=script&lang=js&"
import style0 from "./fullnews.vue?vue&type=style&index=0&id=b97bda5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97bda5a",
  null
  
)

export default component.exports